export const SHARED_RETAIL_FIELDS = ['metricUnit', 'unitWeightKg', 'baseQuantityPerUnit', 'useScaleWeight'];
const code = (format) => String(format.productFormatCode || format.ProductFormat?.code || format.clientType || '').trim().toLowerCase();

export const getRetailConfigurationSource = (format, formats) => code(format) === 'oferta'
  ? formats.find((entry) => !entry.pendingDelete && code(entry) === 'detalle') || null : null;

export const applySharedRetailConfiguration = (formats) => formats.map((format) => {
  const source = getRetailConfigurationSource(format, formats);
  if (!source) return format;
  const fields = Object.fromEntries(SHARED_RETAIL_FIELDS.map((field) => [field, source[field]]));
  return { ...format, ...fields, configurationSourceFormatId: source.id || null,
    configurationSourceFormatKey: source.key || null, sharesRetailConfiguration: true };
});
